import { useRef } from "react";
import YouTube from "react-youtube";
import { motion, AnimatePresence } from "framer-motion";
import { useVideoPlayer } from "../contexts/VideoPlayerContext";
import { X, Minus, ArrowsOut } from "@phosphor-icons/react";

export default function VideoPlayer() {
  const { currentVideo, isMinimized, isVisible, closeVideo, toggleMinimize, skipToNext } = useVideoPlayer();
  const playerRef = useRef(null);

  if (!isVisible || !currentVideo) return null;

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      autoplay: 1,
      controls: 1,
      modestbranding: 1,
      rel: 0,
      playsinline: 1,
    },
  };

  return (
    <AnimatePresence>
      <motion.div
        key="video-player"
        className={isMinimized ? "video-player-minimized" : "video-player-expanded"}
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        data-testid="video-player"
      >
        {/* Header bar */}
        <div className="flex items-center justify-between px-3 py-2 bg-[#141414] border-b border-white/10">
          <p className="text-xs text-white/80 truncate flex-1 mr-2 font-medium" data-testid="video-title">
            {currentVideo.title}
          </p>
          <div className="flex items-center gap-1">
            <button
              onClick={toggleMinimize}
              className="p-1.5 rounded hover:bg-white/10 transition-colors"
              data-testid="video-toggle-minimize"
            >
              {isMinimized ? <ArrowsOut size={14} className="text-white/70" /> : <Minus size={14} className="text-white/70" />}
            </button>
            <button
              onClick={closeVideo}
              className="p-1.5 rounded hover:bg-white/10 transition-colors"
              data-testid="video-close-btn"
            >
              <X size={14} className="text-white/70" />
            </button>
          </div>
        </div>

        {/* YouTube embed */}
        <div className={isMinimized ? "aspect-video" : "h-[360px]"}>
          <YouTube
            key={currentVideo.youtubeId}
            videoId={currentVideo.youtubeId}
            opts={opts}
            onReady={(e) => { playerRef.current = e.target; }}
            onError={() => {
              // YouTube error codes 101/150 = embedding disabled, 100 = not found, 2 = invalid ID
              // Auto-skip to next highlight so user always sees content
              skipToNext();
            }}
            className="w-full h-full"
            iframeClassName="w-full h-full"
          />
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
